<template>
  <div class="clients">
    <div class="inner" v-if="settings && settings.clients && settings.clients.length">
      <div class="heading">Our Clients</div>
      <div class="logos">
        <img :alt="client.name" :key="client._id" :src="client.image" v-for="client in settings.clients" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  data: function() {
    return {}
  },
  computed: {
    ...mapState(["settings"])
  }
}
</script>

<style scoped>
.clients {
  background: #fff;
  padding: 8rem 0;
  font-size: 2rem;
}
.heading {
  color: black;
}
.logos {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  width: 100%;
  grid-gap: 5rem;
}
@media screen and (max-width: 750px) {
  .logos {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 3rem;
  }
}
</style>
